import DateRangePicker from './dateRangePicker/dateRangePicker';
import DateTimePicker from './dateTimePicker/dateTimePicker';
import MonthRangePicker from './monthRangePicker/monthRangePicker';

/**
 * A date picker designed to select a date range in months / quarters / years
 * @author Stan Hurks, Eventix
 */
export default angular.module('eventix.common.directives.datePickers', [DateRangePicker, DateTimePicker, MonthRangePicker])
    .name;
